import React from 'react';
import { palette } from '../../styles/theme';

export function CardsSVG ({ customStroke, strokeWidth = '1.5', className = '', selected = false }) {
    const stroke = customStroke || palette.icons;
    return (
        <span className={className}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <g clipPath="url(#clip0_6966_2362)">
                    <path d="M3.5 8C3.5 7.20435 3.81607 6.44129 4.37868 5.87868C4.94129 5.31607 5.70435 5 6.5 5H18.5C19.2956 5 20.0587 5.31607 20.6213 5.87868C21.1839 6.44129 21.5 7.20435 21.5 8V16C21.5 16.7956 21.1839 17.5587 20.6213 18.1213C20.0587 18.6839 19.2956 19 18.5 19H6.5C5.70435 19 4.94129 18.6839 4.37868 18.1213C3.81607 17.5587 3.5 16.7956 3.5 16V8Z" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M3.5 10H21.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7.5 15H7.51" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M11.5 15H13.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_6966_2362">
                        <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
                    </clipPath>
                </defs>
            </svg>
        </span>
    );
}
